"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageMetadata = void 0;
/**
 * @hidden
 */
exports.packageMetadata = {
    name: '@progress/kendo-react-upload',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1695802948,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};
